const downloadModuleEnum = {
  HOLE_PAPER: {
    code: 0,
    name: "HOLE_PAPER",
    desc: "整张试卷",
    kind: "downloadModule"
  },
  QUESTION: {
    code: 1,
    name: "QUESTION",
    desc: "题号模块",
    kind: "downloadModule"
  },
}

export default Object.freeze(downloadModuleEnum)